import { Component } from '@angular/core';
import { CVA_CONSTANTS } from '../../util/constants';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'cva-patient-consent',
    templateUrl: './patient-consent.component.html',
    styleUrl: './patient-consent.component.scss',
    
})
export class PatientConsentComponent {
  CVA_CONSTANTS = CVA_CONSTANTS

  constructor(
    private readonly dialogRef: MatDialogRef<PatientConsentComponent>
  ) { }

  consentTaken() {
    this.dialogRef.close(true);
  }

}
